// You might notice this piece of code should sit with enquiry-form.js
// so why we put it here? Simply because of how fast the user data prepopulate. This approach showing that user data prepopulate significantly faster.
// thats why we decide to keep this file as seperate and load before any enquiry script as [@Vincent Lowe] suggested

import UserDataService from '../../../Shared/Assets/userdata-service';

const targetFields = ["Fullname", "Email", "Phone", "Postcode"];

let infoWithNewLineSuffix = [];
let infoMisc = [];
let fieldCategory = {
    "Fullname": infoWithNewLineSuffix,
    "Email": infoWithNewLineSuffix,
    "Phone": infoMisc,
    "Postcode": infoMisc
}

let prefilledFields = 0;
let defaultFields = 0;

function forEachConsolidatedInfoContainer(fn) {
    [...document.querySelectorAll(".main-enquiry-section label.my-contact-details")].forEach(fn);
}

function forEachInputField(fn) {
    targetFields.forEach(key => {
        [...document.querySelectorAll(`.main-enquiry-section input[name=\"${key}\"]`)].forEach(fn);
    });
}

function consolidateVerticalDefaultValues() {
    targetFields.forEach(key => {
        [...document.querySelectorAll(`.main-enquiry-section input[id="Vertical_${key}"]`)].forEach(element => {
            if (element.value) {
                defaultFields++;
                fieldCategory[key].push(element.value);
            }
        });
    });
}

function resetConsolidatedInfo() {
    infoWithNewLineSuffix = [];
    infoMisc = [];
    fieldCategory = {
        "Fullname": infoWithNewLineSuffix,
        "Email": infoWithNewLineSuffix,
        "Phone": infoMisc,
        "Postcode": infoMisc
    }
}

try {
    consolidateVerticalDefaultValues();

    let data = new UserDataService().loadData({ data: { "cmp.ret.enq.details": null }, storeIn: 0 }).data;
    data = JSON.parse(data["cmp.ret.enq.details"]);

    // reset default profile values for local storage prefill
    if (data && targetFields.every(field => data[field])) {
        resetConsolidatedInfo();
    }

    for (let key in data) {
        if (!data.hasOwnProperty(key) || !targetFields.includes(key)) continue;
        [...document.querySelectorAll(`.main-enquiry-section input[name=\"${key}\"]`)]
            .forEach(elem => elem.value = data[key]);

        if (data[key]) {
            prefilledFields++;
            fieldCategory[key].push(data[key]);
        }
    }

    let isBnc = false;
    const bnc = document.querySelector(".main-enquiry-section input[name='IsBncStock']");
    if (bnc && bnc.value === "True") isBnc = true;

    if ((prefilledFields === targetFields.length || defaultFields === targetFields.length) && !isBnc) {
        forEachInputField(element => element.parentElement.parentElement.style.display = "none");
        forEachConsolidatedInfoContainer(element => {
            element.innerText = [...infoWithNewLineSuffix, infoMisc.join(", ")].join("\n");
            element.parentElement.addEventListener("click",
                () => element.dispatchEvent(new Event("edit-contact-details", { bubbles: true, cancelable: true }),
                    { once: true }));
        });

        document.body.addEventListener("edit-contact-details", () => {
            forEachInputField(element => element.parentElement.parentElement.style.display = "flex");
            forEachConsolidatedInfoContainer(element => element.parentElement.parentElement.style.display = "none");
        }, { once: true });
    } else {
        forEachConsolidatedInfoContainer(element => element.parentElement.parentElement.style.display = "none");
    }
} catch (err) {
    console.log(err);
}